//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      design: {}
    }
  },
  fetch () {
    console.log(`Fetching product info ${process.server ? 'server-side' : 'client-side'} for product #${this.productId} (${this.baseSku})`)
    const { error } = this.$nuxt.context

    try {
      if (this.skuPrefix === 'case') {
        this.design = {
          snowcapsule: { ct: 'revoltcapsule' },
          pacecapsule: { ct: 'pacecapsule' },
          compactsnipers: { ct: 'compactsnipers' },
          compactvanguards: { ct: 'compactvanguards' },
          capsule: { ct: 'capsule' }
        }[this.productLookupKey]
      }
    } catch (e) {
      this.$sentry.captureException(e)
      error({
        statusCode: 503,
        message: 'Unable to load product details'
      })
    }
  },
  fetchDelay: 0,
  computed: {
    productId () { return this.pageData.product_id },
    skuPrefix () { return this.pageData.skuPrefix },
    allProductDetails () { return this.$store.getters['product/product'](this.productId) || {} },
    productDetails () { return this.allProductDetails.product_details || {} },
    selectionMapping () {
      return Object.fromEntries(Object.entries(this.bundleConfig.options || {}).map(([optionId, option]) => {
        return Object.entries(option.selections).map(([selectionId, selection]) => {
          return [selection.sku, { optionId, selectionId }]
        })
      }).flat())
    },
    ecomProduct () { return this.allProductDetails.product },
    bundleConfig () { return this.allProductDetails.bundle_config || {} },
    productName () {
      if (this.skuPrefix === 'case') {
        return {
          snowcapsule: 'Snow Series™ Capsule Case',
          pacecapsule: 'Pace Series™ Capsule Case',
          capsule: 'Sunglasses Capsule Case',
          compactsnipers: 'Snipers™ Compact Case',
          compactvanguards: 'Vanguards™ Compact Case'
        }[this.productLookupKey] || 'Sunglasses Capsule Case'
      }
      return this.ecomProduct.name
    },
    productLookupKey () {
      return this.$route.path.split('/').pop()
    },
    images () {
      return {
        snowcapsule: [
          '/cart/case-ct_revoltcapsule.png',
          '/cart/case-ct_revoltcapsule_top.png',
          '/cart/case-ct_revoltcapsule_side.png'
        ],
        pacecapsule: [
          '/cart/case-ct_pacecapsule.png',
          '/cart/case-ct_pacecapsule_top.png',
          '/cart/case-ct_pacecapsule_side.png'
        ],
        capsule: [
          '/cart/case-ct_capsule.png',
          '/cart/case-ct_capsule_top.png',
          '/cart/case-ct_capsule_side.png'
        ],
        compactsnipers: [
          '/cart/case-ct_compactsnipers.png',
          '/cart/case-ct_compactsnipers_empty.png',
          '/cart/case-ct_compactsnipers_full.png'
        ],
        compactvanguards: [
          '/cart/case-ct_compactvanguards.png',
          '/cart/case-ct_compactvanguards_empty.png',
          '/cart/case-ct_compactvanguards_full.png'
        ]
      }[this.productLookupKey] || []
    },
    description () {
      if (this.skuPrefix === 'case') {
        return {
          snowcapsule: 'Protect your Snipers™, Revolts™ or Vanguards™ with this super-durable, compact hard shell case.\nConstructed from re-inforced nylon with chunky, adventure-proof features, the Capsule Case is guaranteed to keep your SunGods safe on every adventure.',
          pacecapsule: 'Protect your Vulcans™, Airas™ or Velans™ with this super-durable, compact hard shell case.\nConstructed from re-inforced nylon with chunky, adventure-proof features, the Capsule Case is guaranteed to keep your SunGods safe on every adventure.',
          capsule: 'Protect your Classics³, Sierras™ or Renegades™ with this super-durable, compact hard shell case.\nConstructed from re-inforced nylon with chunky, adventure-proof features, the Capsule Case is guaranteed to keep your SunGods safe on every adventure.',
          compactvanguards: 'Protect your Vanguards™ with this super-durable, compact case.\nConstructed from re-inforced nylon with chunky, adventure-proof features and spare microfibre pouch, the Capsule Case is guaranteed to keep your SunGods safe on every adventure.',
          compactsnipers: 'Protect your Snipers™ with this super-durable, compact case.\nConstructed from re-inforced nylon with chunky, adventure-proof features and spare microfibre pouch, the Capsule Case is guaranteed to keep your SunGods safe on every adventure.'
        }[this.productLookupKey]
      }
      return this.ecomProduct.description
    },
    isInStock () {
      return this.$store.getters['product/isInStock'](this.sku)
    },
    designDetails () {
      return Object.fromEntries(Object.entries(this.design).map(([part, choice]) => {
        return [part, {
          [`bundle${this.ecomProduct.entity_id}`]: {
            optionId: this.selectionMapping[`${part}_${choice}`].optionId,
            selectId: this.selectionMapping[`${part}_${choice}`].selectionId
          }
        }]
      }))
    },
    price () {
      return this.$store.getters['bundle/price'](this.bundleConfig, this.designDetails)
    },
    sku () {
      return [this.skuPrefix, ...Object.entries(this.design).map(([part, choice]) => `${part}_${choice}`)].join('-')
    }
  },
  mounted () {
    this.$nextTick(() => this.$track.ecommerce.viewProductPage([{ sku: this.sku }]))
  },
  methods: {
    addToCart () {
      this.$refs.bundle.addToCart()
    }
  }
}
